import React, { createContext, useContext, useReducer, useEffect } from "react";

const AuthContext = createContext();

// Initial state
const initialState = {
  user: null,
  isAuthenticated: false,
  loading: true,
};

// Auth reducer
const authReducer = (state, action) => {
  switch (action.type) {
    case "LOGIN_SUCCESS":
      return {
        ...state,
        user: action.payload,
        isAuthenticated: true,
        loading: false,
      };
    case "LOGOUT":
      return {
        ...state,
        user: null,
        isAuthenticated: false,
        loading: false,
      };
    case "AUTH_CHECK_COMPLETE":
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
};

export const AuthProvider = ({ children }) => {
  const [state, dispatch] = useReducer(authReducer, initialState);

  useEffect(() => {
    // Check for existing auth token
    const token = localStorage.getItem("adminToken");
    const user = localStorage.getItem("adminUser");

    if (token && user) {
      dispatch({
        type: "LOGIN_SUCCESS",
        payload: JSON.parse(user),
      });
    } else {
      dispatch({ type: "AUTH_CHECK_COMPLETE" });
    }
  }, []);

  const login = async (email, password) => {
    try {
      // Mock login - replace with actual API call
      if (email === "admin@ecommerce.com" && password === "admin123") {
        const user = {
          id: 1,
          email: "admin@ecommerce.com",
          name: "Admin User",
          role: "admin",
        };

        localStorage.setItem("adminToken", "mock-jwt-token");
        localStorage.setItem("adminUser", JSON.stringify(user));

        dispatch({
          type: "LOGIN_SUCCESS",
          payload: user,
        });

        return { success: true };
      } else {
        throw new Error("Invalid credentials");
      }
    } catch (error) {
      return { success: false, error: error.message };
    }
  };

  const logout = () => {
    localStorage.removeItem("adminToken");
    localStorage.removeItem("adminUser");
    dispatch({ type: "LOGOUT" });
  };

  const value = {
    ...state,
    login,
    logout,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
